import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import SearchPopup from "./components/SearchPopup";
import LanguageModal from "./components/LanguageModal";
import Preloader from "./components/Preloader";
import ScrollTop from "./components/ScrollTop";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import TermsAndCondition from "./pages/TermsAndCondition";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Contact from "./pages/Contact";
import BlogsList from "./pages/BlogsList";
import SingleBlog from "./pages/SingleBlog";
import CurrentAffairs from "./pages/CurrentAffairs";
import CurrentAffairDetail from "./pages/CurrentAffairDetail";
import ExamNoteContent from "./pages/exam-notes/ExamNoteContent";
import {
  ExamContentsPage,
  ExamListPage,
  ExamSubjectsPage,
  ExamSubtopicsPage,
  ExamTopicsPage,
} from "./pages/exam-notes/ExamNotesPages";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import CourseCheckout from "./pages/CourseCheckout";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import MyCourse from "./pages/MyCourse";
import TestAttempt from "./pages/TestAttempt";
import TestResult from "./pages/TestResult";
import TestAnalysis from "./pages/TestAnalysis";
import ProtectedRoute from "./components/ProtectedRoute";
import { getToken } from "./api/auth";
import RefundPolicy from "./pages/RefundPolicy";
import { SiteLogoProvider } from "./api/siteLogo";

/* ---------- LAYOUT WRAPPER ---------- */
function LayoutWrapper({ children }) {
  const { pathname } = useLocation();
  const hideLayout = pathname === "/login" || pathname === "/register";

  return (
    <>
      {!hideLayout && <Header />}
      {children}
      {!hideLayout && <Footer />}
    </>
  );
}

/* ---------- APP ---------- */
function App() {
  const isLoggedIn = !!getToken();

  return (
    <BrowserRouter>
      <SiteLogoProvider>
      <Preloader />
      <Sidebar />
      <SearchPopup />
      <LanguageModal />
      <ScrollTop />

      <LayoutWrapper>
        <Routes>
          {/* ---------- PUBLIC ROUTES ---------- */}
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route
            path="/courses/:id/pay"
            element={
              <ProtectedRoute>
                <CourseCheckout />
              </ProtectedRoute>
            }
          />
          <Route path="/courses/:id" element={<CourseDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blog" element={<BlogsList />} />
          <Route path="/blog/:slug" element={<SingleBlog />} />
          <Route path="/current-affairs" element={<CurrentAffairs />} />
          <Route path="/current-affairs/:id" element={<CurrentAffairDetail />} />
          <Route path="/exam-notes" element={<ExamListPage />} />
          <Route path="/exam-notes/content/:id" element={<ExamNoteContent />} />
          <Route path="/exam-notes/:examId" element={<ExamSubjectsPage />} />
          <Route path="/exam-notes/:examId/subjects/:subjectId" element={<ExamTopicsPage />} />
          <Route
            path="/exam-notes/:examId/subjects/:subjectId/topics/:topicId"
            element={<ExamSubtopicsPage />}
          />
          <Route
            path="/exam-notes/:examId/subjects/:subjectId/topics/:topicId/subtopics/:subtopicId"
            element={<ExamContentsPage />}
          />

          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/contact" element={<Contact />} />

          {/* ---------- AUTH ROUTES (BLOCK IF LOGGED IN) ---------- */}
          <Route
            path="/login"
            element={isLoggedIn ? <Navigate to="/" replace /> : <Login />}
          />
          <Route
            path="/register"
            element={isLoggedIn ? <Navigate to="/" replace /> : <Register />}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-courses/:courseId/tests/:kind/:testId/result"
            element={
              <ProtectedRoute>
                <TestResult />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-courses/:courseId/tests/:kind/:testId/analysis"
            element={
              <ProtectedRoute>
                <TestAnalysis />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-courses/:courseId/tests/:kind/:testId"
            element={
              <ProtectedRoute>
                <TestAttempt />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-courses/:courseId"
            element={
              <ProtectedRoute>
                <MyCourse />
              </ProtectedRoute>
            }
          />

          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<TermsAndCondition />} />



          {/* ---------- FALLBACK ---------- */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </LayoutWrapper>
      </SiteLogoProvider>
    </BrowserRouter>
  );
}

export default App;
